(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annoucment-contdown"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.announcement-slider').slick({
      infinite: true,
      autoplay: true,
      arrows: false,
      dots: false,
      autoplaySpeed: 3000,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    function updateCountdown() {
      $('.countdown-timer').each(function() {
        const $timer = $(this);
        const endTime = new Date($timer.data('end')).getTime();
        const now = new Date().getTime();
        const diff = endTime - now;

        if (diff <= 0) {
          $timer.html('<div class="countdown-ended">Sale ended</div>');
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        $timer.find('.days').text(days.toString().padStart(2, '0'));
        $timer.find('.hours').text(hours.toString().padStart(2, '0'));
        $timer.find('.minutes').text(minutes.toString().padStart(2, '0'));
        $timer.find('.seconds').text(seconds.toString().padStart(2, '0'));
      });
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card-slider"] && !window.DesignMode) return;
  try {
    
  $('.card_image_slider').slick({
  dots: false,
  arrows: true,
  slidesToShow: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 979,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        dots: true,
         slidesToShow: 1
      }
    }
  ]
});



  } catch(e) { console.error(e); }
})();
})();
